import React, { Component } from 'react'
import { Button, Form, InputNumber, Select, Space } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { SalesTaxesTypeArray } from '../../../../../interfaces/IShelterPaymentConfig'

export default class SalesTaxes extends Component {
  render() {
    const typeOptions = SalesTaxesTypeArray.map(value => {
      return {
        value
      }
    })

    return (
      <Form.List name="sales_taxes">
        {(fields, { add, remove }) => (
          <Space direction="vertical">
            {
              fields.map(field => {

                return (
                  <Space key={`sales_taxes_${field.key}`} direction="horizontal">
                    <Form.Item
                      {...field}
                      label="Type"
                      name={[field.name, 'type_key']}
                      rules={[
                        {
                          required: true,
                          message: 'Required field'
                        }
                      ]}
                    >
                      <Select
                        placeholder="Select a type"
                        options={typeOptions}
                        style={{minWidth: 200}}
                      />
                    </Form.Item>
    
                    <Form.Item
                      {...field}
                      label="Value"
                      name={[field.name, 'value']}
                      rules={[
                        {
                          required: true,
                          message: 'Required field'
                        }
                      ]}
                    >
                      <InputNumber min={0} />
                    </Form.Item>

                    <Button type="dashed" shape="circle" icon={<DeleteOutlined />} onClick={() => remove(field.key)} />
                  </Space>
                )
              })
            }

            <Button
              type="dashed"
              onClick={() => add()}
            >
              Add Rule
            </Button>
          </Space>
        )}
      </Form.List>
    )
  }
}
